<template>

  <div v-if="currentUser">
    <b-navbar toggleable="lg" type="dark bg-dark" variant="info">
      <b-navbar-brand :to="{name: currentUser ? 'Sites' : 'Login'}">{{env.VUE_APP_UI.title}}</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item v-if="hasCurrentUserClaims(['a'])" :to="{name: 'Users'}">{{$t('users.title')}}</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">

          <b-nav-item-dropdown right>
            <template #button-content>
              <em>{{profileName}}</em>
            </template>
            <b-dropdown-item v-if="hasCurrentUserClaims(['a'])" :to="{name: 'UserEdit', params: {uid: 'me'}}">{{$t('users.editMe')}}</b-dropdown-item>
            <b-dropdown-item href="#" @click="logout">{{$t('login.out')}}</b-dropdown-item>
          </b-nav-item-dropdown>

        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>

</template>

<script>

import firebase from 'firebase';
import SkVars from '../mixins/SkVars'

export default {
  name: 'Navbar',
  mixins: [SkVars],

  data () {
    return {
    }
  },

  computed: {
    profileName: function () {
      return this.currentUser.displayName || this.currentUser.email
    }
  },

  methods: {
      logout() {
          firebase.auth().signOut().then(() => {
              this.$router.push({name: 'Login'});
          });
      }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Navbar.vue